// Planned recipe titles become links (redesign slice 4). On the plan pages a
// dish's title still sits inside its search field until the Plan redesign
// (slice 5), so those rows get an "Open" link beside the field; titles that
// are plain text (the week's snack, preserves and medicinal lists) become
// links themselves.
import { Link } from "react-router-dom";
import { COLORS, FONT_SIZE, LAYOUT } from "../lib/constants";

export function OpenRecipeLink({ recipeId, title }: { recipeId: string; title?: string }) {
  return (
    <Link
      to={`/recipes/${recipeId}`}
      aria-label={title ? `Open ${title}` : "Open recipe"}
      className="mp-sans"
      style={{ display: "inline-flex", alignItems: "center", minHeight: LAYOUT.tapTarget, padding: "0 var(--space-xs)", color: COLORS.accent, fontSize: FONT_SIZE.sm, fontWeight: 700, textDecoration: "none", flexShrink: 0 }}
    >
      Open
    </Link>
  );
}

export function RecipeTitleLink({ recipeId, title }: { recipeId: string; title: string }) {
  return (
    <Link to={`/recipes/${recipeId}`} style={{ color: "inherit", textDecorationColor: COLORS.line, textUnderlineOffset: 3 }}>
      {title}
    </Link>
  );
}
